import { render } from "./AddressBookDashboard.vue?vue&type=template&id=d8ce9be6&scoped=true"
import script from "./AddressBookDashboard.vue?vue&type=script&lang=js"
export * from "./AddressBookDashboard.vue?vue&type=script&lang=js"

import "./AddressBookDashboard.vue?vue&type=style&index=0&id=d8ce9be6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8ce9be6"]])

export default __exports__